import React from 'react';
import { getMessage } from '@tcc/i18n';
import styles from './css/SprayAssistTooltip.css';
import SprayAssistBadge from './SprayAssistBadge';

function SprayAssistTooltip() {

  return (
    <div className={styles.tooltipContainer} data-test-id="sprayAssistTooltipContainer">
      <div className={styles.tooltipText} data-test-id="tooltip-text">

        <div className={styles.tooltipParagraph}>
          {getMessage('forecast.sprayAssist.tooltip.SWFDescription').split('{0}')[0]}
          <strong>{getMessage('forecast.sprayAssist.tooltip.suitableConditions')}</strong>
          {getMessage('forecast.sprayAssist.tooltip.SWFDescription').split('{0}')[1]}
          </div>
        <div className={styles.tooltipParagraph}>
          <ul>
            <li>{getMessage('forecast.sprayAssist.tooltip.item.wind')}</li>
            <li>{getMessage('forecast.sprayAssist.tooltip.item.temperature')}</li>
            <li>{getMessage('forecast.sprayAssist.tooltip.item.precipitation')}</li>
            <li>{getMessage('forecast.sprayAssist.tooltip.item.temperatureInversion')}</li>
            <li>{getMessage('forecast.sprayAssist.tooltip.item.deltaT')}</li>
          </ul>
        </div>
        <div className={`${styles.tooltipParagraph} ${styles.sprayConditionParagraph}`}>

          <div className={styles.sprayCondition}>
            <div className={styles.conditionRow}>
              {getMessage('forecast.sprayAssist.tooltip.idealCondition')}
              <SprayAssistBadge sprayAssistValue='GOOD' />
            </div>
            <div>{getMessage('forecast.sprayAssist.tooltip.idealCondition.description')}</div>
          </div>

          <div className={styles.sprayCondition}>
            <div className={styles.conditionRow}>
              {getMessage('forecast.sprayAssist.tooltip.fairCondition')}
              <SprayAssistBadge sprayAssistValue='MODERATE' />
            </div>
            <div>{getMessage('forecast.sprayAssist.tooltip.fairCondition.description')}</div>
          </div>

          <div className={styles.sprayCondition}>
            <div className={styles.conditionRow}>
              {getMessage('forecast.sprayAssist.tooltip.poorCondition')}
              <SprayAssistBadge sprayAssistValue='POOR' />
            </div>
            <div>{getMessage('forecast.sprayAssist.tooltip.poorCondition.description')}</div>
          </div>

        </div>
        <div className={styles.tooltipParagraph}>{getMessage('forecast.sprayAssist.tooltip.SWFUpdate')}</div>
        <div className={styles.tooltipParagraph}>{getMessage('forecast.sprayAssist.tooltip.SWFconditions')}</div>

      </div>
    </div>
  );
}

export default SprayAssistTooltip;
